






import app from "@/app";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";

@Component
export default class PUserEdit extends BaseComponent {
	user = app.user.getCurrentUser();
	done(response: any) {
		app.user.setCurrentUser(response.data.item);

		app.view.dialog({
			type: "done",
			text: "OO_LANG_USER_INFO_EDITED"
		});

		app.router.goBack();
	}
	ignored() {
		app.router.goBack();
	}
}
